/**
 * Shared "should this press start a drag?" policy for the sidepanel's drag
 * surfaces (panel reposition from the toolbar, section reorder from headers).
 * Interactive elements keep their clicks — a press on them is never a drag —
 * and anything else opts out explicitly via `[data-no-drag]`.
 */
const DRAG_EXCLUDED_SELECTOR = 'button, [role="button"], a, input, textarea, [data-no-drag]'

export function isDragExcluded(target: EventTarget | null): boolean {
  return target instanceof Element && target.closest(DRAG_EXCLUDED_SELECTOR) !== null
}
